module.exports = __webpack_public_path__ + "img/menu_note_on.ff298cba.svg";